import { useMemo } from "react";
export const useStaticMapUrl = ({ template, locale, id, width, height, zoom, mode = "light", }) => useMemo(() => {
    if (!width || !height)
        return null;
    const urlString = template
        .replace(":locale", locale)
        .replace(":id", id)
        .replace(":width", width.toFixed(0))
        .replace(":height", height.toFixed(0))
        .replace(":scale", (Math.min(devicePixelRatio, 2) || 1).toFixed(0))
        .replace(":zoom", zoom ? zoom.toFixed(0) : "");
    const url = new URL(urlString);
    url.searchParams.set("mode", mode);
    return url.toString();
}, [template, locale, id, width, height, zoom, mode]);
